/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	// The require scope
/******/ 	var __webpack_require__ = {};
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
/*!******************************************!*\
  !*** ./src/scripts/product/pdp-popup.js ***!
  \******************************************/
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
var pdpPopup = function pdpPopup() {
  return {
    init: function init(el) {
      var _this = this;
    },
    togglePdpTab: function togglePdpTab(el) {
      console.log('switch tab');
      var _this = this;
      var tabControllerId = el.getAttribute('data-tab');
      var pdpPopup = document.querySelector('.pdp-popup');
      var allPopupTabController = pdpPopup.querySelectorAll('.tab-control-wrapper .tab-control button');
      var allPopupTabContent = pdpPopup.querySelectorAll('.tab-content-wrapper .tab-content');
      allPopupTabController.forEach(function (tabController) {
        tabController.classList.remove('active');
      });
      allPopupTabContent.forEach(function (tabContent) {
        tabContent.classList.remove('active');
      });
      el.classList.add('active');
      pdpPopup.querySelector(".tab-content-wrapper .tab-content[data-tab=\"".concat(tabControllerId, "\"]")).classList.add('active');
    },
    closePopup: function closePopup() {
      var _this = this;
      document.body.classList.remove('pdp-popup-active');
    }
  };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (pdpPopup);
document.addEventListener("alpine:init", function () {
  Alpine.data("pdpPopup", pdpPopup);
});
/******/ })()
;